import { render, staticRenderFns } from "./rolebinding.vue?vue&type=template&id=4e68d90c&scoped=true&"
import script from "./rolebinding.vue?vue&type=script&lang=js&"
export * from "./rolebinding.vue?vue&type=script&lang=js&"
import style1 from "./rolebinding.vue?vue&type=style&index=1&id=4e68d90c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e68d90c",
  null
  
)

export default component.exports